import React from 'react';
import {
    useColorScheme
} from '@mui/material/styles';

// Icons
import DarkMode from '@mui/icons-material/DarkMode';
import LightMode from '@mui/icons-material/LightMode';

import IconButton from '@mui/material/IconButton';
import { ThemeName } from '../types';

const ModeToggle: React.FC = () => {
    const { mode, setMode } = useColorScheme();
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
    }, []);
    if (!mounted) return null;

    const toggleMode = (): void => {
        const nextMode: ThemeName = mode === 'dark' ? 'light' : 'dark';
        setMode(nextMode);
    };

    return (
        <IconButton onClick={toggleMode}>
            {mode === 'dark' ? <DarkMode /> : <LightMode />}
        </IconButton>
    );
};

export default ModeToggle;